import Piece from './Piece.js'

export default Piece
